import React from 'react';

const VedantaHighlightsColTwo = () => {
  return (
    <div className="highlights-col">
      <h5>3.26 Million</h5>
      <p>CSR programme beneficiaries</p>

      <h5>INR 21,061 Crore</h5>
      <p>EBITDA</p>

      <h5>INR 7,130 Crore</h5>
      <p>
        Free cash flow <br />
        (post-capex)
      </p>
    </div>
  );
};

export default VedantaHighlightsColTwo;
